import AccessControlListTab from './AccessControlListTab';
import ManagersTab from './ManagersTab';
import ManagersView from './ManagersView';

export default {
  AccessControlListTab,
  ManagersTab,
  ManagersView,
};
